/**
 * 記事編集画面において、選択されたカテゴリの変更を監視します。
 *
 * カテゴリの選択状態が変わると、'mtappCategoryChanged' イベントが発火します。
 *
 * ### 使用例
 *
 * 1. カテゴリの変更を監視する:
 *    ```javascript
 *    observeCategoryChange();
 *    ```
 *
 * 2. カテゴリの変更を検知するリスナーを設定 (Vanilla JS):
 *    ```javascript
 *    document.getElementById('category-ids').addEventListener('mtappCategoryChanged', function(event) {
 *        const newCategoryIds = event.detail.newValue;
 *        console.log('カテゴリが変更されました。新しいカテゴリID:', newCategoryIds);
 *    });
 *    ```
 *
 * 3. カテゴリの変更を検知するリスナーを設定 (jQuery):
 *    ```javascript
 *    jQuery('#category-ids').on('mtappCategoryChanged', function(event) {
 *        const newCategoryIds = event.originalEvent.detail.newValue;
 *        console.log('カテゴリが変更されました。新しいカテゴリID:', newCategoryIds);
 *    });
 *    ```
 *
 * @returns {void}
 */
export function observeCategoryChange() {
    if (!['edit-entry', 'edit-page'].includes(mtappVars.screen_id)) {
        return;
    }
    mtappVars.categoryIdsField = document.getElementById('category-ids');
    if (mtappVars.categoryIdsField) {
        // グローバル変数であるmtappVars.selectedCategoriesの初期値を設定
        mtappVars.selectedCategories = mtappVars.categoryIdsField.value;

        // 初期状態のイベントを作成
        window.mtappCategoryChangedEvent = new CustomEvent('mtappCategoryChanged', {
            detail: {
                newValue: mtappVars.selectedCategories ? mtappVars.selectedCategories.split(',') : ''
            }
        });

        // カテゴリの選択状態の変更を監視するインターバルを設定
        window.setInterval(function () {
            if (mtappVars.selectedCategories !== mtappVars.categoryIdsField.value) {
                mtappVars.selectedCategories = mtappVars.categoryIdsField.value;

                // イベントの詳細情報を更新
                window.mtappCategoryChangedEvent.detail.newValue = mtappVars.selectedCategories
                    ? mtappVars.selectedCategories.split(',')
                    : '';

                // カテゴリの選択状態が変更されたことを示すイベントを発火
                mtappVars.categoryIdsField.dispatchEvent(window.mtappCategoryChangedEvent);
            }
        }, 150);
    }
}

/**
 * 初期状態のカテゴリIDを取得し、カテゴリ変更イベントを発火させます。
 */
export function observeCategoryChangeCheck() {
    if (!['edit-entry', 'edit-page'].includes(mtappVars.screen_id)) {
        return;
    }
    if (mtappVars.categoryIdsField && window.mtappCategoryChangedEvent) {
        // 初期状態のイベントを発火
        mtappVars.categoryIdsField.dispatchEvent(window.mtappCategoryChangedEvent);
    }
}
